// Simple, deterministic card-tokenization utility (client-side simulation).
// In a real system this would be done by a PCI-compliant tokenization vault.
// We never persist the full PAN — only the token + masked version.

const TOKEN_PREFIX = "tok_";
const CHARS = "abcdefghijklmnopqrstuvwxyz0123456789";

function randomSegment(len) {
  let out = "";
  for (let i = 0; i < len; i++) {
    out += CHARS[Math.floor(Math.random() * CHARS.length)];
  }
  return out;
}

export function tokenizePan(pan) {
  // Strip spaces
  const clean = pan.replace(/\s+/g, "");
  // Build a deterministic-ish but opaque token
  const ts = Date.now().toString(36).slice(-6);
  const rand = randomSegment(20);
  return `${TOKEN_PREFIX}${ts}_${rand}`;
}

export function maskPan(pan) {
  const clean = pan.replace(/\s+/g, "");
  const last4 = clean.slice(-4);
  return `•••• ${last4}`;
}

export function last4Of(pan) {
  return pan.replace(/\s+/g, "").slice(-4);
}

// Luhn check for card number validity
export function luhnValid(pan) {
  const clean = pan.replace(/\s+/g, "");
  if (!/^\d{13,19}$/.test(clean)) return false;
  let sum = 0;
  let shouldDouble = false;
  for (let i = clean.length - 1; i >= 0; i--) {
    let d = parseInt(clean[i], 10);
    if (shouldDouble) {
      d *= 2;
      if (d > 9) d -= 9;
    }
    sum += d;
    shouldDouble = !shouldDouble;
  }
  return sum % 10 === 0;
}

export function detectBrand(pan) {
  const clean = pan.replace(/\s+/g, "");
  if (/^4/.test(clean)) return "visa";
  if (/^(5[1-5]|2[2-7])/.test(clean)) return "mastercard";
  if (/^3[47]/.test(clean)) return "amex";
  if (/^6(?:011|5)/.test(clean)) return "discover";
  return "unknown";
}

export function formatCardNumber(value) {
  const clean = value.replace(/\D/g, "").slice(0, 19);
  return clean.replace(/(.{4})/g, "$1 ").trim();
}

export function formatExpiry(value) {
  const clean = value.replace(/\D/g, "").slice(0, 4);
  if (clean.length <= 2) return clean;
  return `${clean.slice(0, 2)}/${clean.slice(2)}`;
}